module.exports = __webpack_public_path__ + "static/media/orat-img-004.d43c3bd5.jpg";